/**
 * 拓扑插件-节点样式参数配置
 */


/**
 * 拓扑插件-状态样式-节点默认样式参数配置
 * @type attrs 节点默认样式参数
 */
export const defaultStyle = {
  // 节点大小
  size: 80,
  // 非必填，Array型，指定边连入节点的连接点的位置（相对于该节点而言），可以为空。例如: [0, 0]，代表节点左上角的锚点，[1, 1],代表节点右下角的锚点
  anchorPoints: [
    [0, 0],
    [0, 0.5],
    [0, 1],
    [0.5, 0],
    [0.5, 1],
    [1, 0],
    [1, 0.5],
    [1, 1]
  ],
  // 节点样式配置
  style: {
    // 非必填，String型，节点填充色
    // fill: 'rgba(48, 161, 255, 1)',
    // 非必填，String型，节点的描边颜色
    stroke: '#666',
    // 非必填，Number型，描边宽度
    lineWidth: 0,
    // 非必填，Number[]型，描边虚线，数组代表实、虚长度
    // lineDash: [],
    // 非必填，String型，阴影颜色
    // shadowColor: '',
    // 非必填，Number型，阴影范围
    // shadowBlur: 0,
    // 非必填，Number型，阴影 x 方向偏移量
    // shadowOffsetX: 0,
    // 非必填，Number型，阴影 y 方向偏移量
    // shadowOffsetY: 0,
    // 非必填，Number型，设置绘图的当前 alpha 或透明值
    opacity: 1,
    // 非必填，Number型，设置填充的 alpha 或透明值
    fillOpacity: 1
    // 非必填，String型，鼠标在该节点上时的鼠标样式，CSS 的 cursor 选项都支持
    // cursor: ''
  },
  // 节点上的标签文本配置
  labelCfg: {
    // 非必填，String型，文本相对于节点的位置，目前支持的位置有：'center'，'top'，'left'，'right'，'bottom'。默认为 'center'。modelRect 节点不支持该属性
    position: 'bottom',
    // 	非必填，Number型，文本的偏移，position 为 'bottom' 时，文本的上方偏移量；position 为 'left' 时，文本的右方偏移量；以此类推在其他 position 时的情况。modelRect 节点的 offset 为左边距
    offset: 5,
    // 节点上的标签文本样式配置
    style: {
      // 非必填，String型，文本颜色
      fill: '#666',
      // 非必填，String型，文本描边颜色
      // stroke: '',
      // 非必填，Number型，文本描边粗细
      // lineWidth: '',
      // 非必填，Number型，文本透明度
      opacity: 1,
      // 非必填，String型，文本字体
      fontFamily: '微软雅黑',
      // 非必填，Number型，文本字体大小
      fontSize: 14
    }
  }
};



/**
 * 拓扑插件-状态样式-字体图标默认样式
 * @type attrs 默认样式
 */
export const iconFontDefaultStyles = {
  'icon-background-shape': {
    stroke: '#cde0f6',
    fill: '#e1edfb'
  },
  'icon-image-shape': {
    fill: '#000',
    shadowColor: '',
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0
  }
};



/**
 * 拓扑插件-状态样式-节点默认状态样式
 * @type attrs 节点默认状态样式
 */
export const defaultStyles = {
  shadowColor: '',
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,

  ...iconFontDefaultStyles
};



/**
 * 拓扑插件-状态样式-唤起，鼠标经过/悬停样式
 * @type attrs 唤起，鼠标经过/悬停样式
 */
export const activeStyles = {
  shadowColor: '#5f95ff',
  shadowBlur: 10,
  shadowOffsetX: 0,
  shadowOffsetY: 0,

  ...iconFontDefaultStyles
};


/**
 * 拓扑插件-状态样式-不可用/不可选样式
 * @type attrs 不可用/不可选样式
 */
export const disableStyles = {
  shadowColor: '#858585',
  shadowBlur: 10,
  shadowOffsetX: 0,
  shadowOffsetY: 0,

  'icon-background-shape': {
    stroke: '#a7a8ab',
    fill: '#d1d1d2'
  },
  'icon-image-shape': {
    fill: '#77797f',
    shadowColor: '',
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0
  }
};


/**
 * 拓扑插件-状态样式-选中节点的样式集合
 * @type attrs 选中节点的样式
 */
export const selectedStyles = {
  shadowColor: '#0c4abd',
  shadowBlur: 12,
  shadowOffsetX: 0,
  shadowOffsetY: 0,

  ...iconFontDefaultStyles
};


/**
 * 拓扑插件-状态样式-告警时样式集合
 * @type attrs 告警时样式
 */
export const warningStyles = {
  shadowColor: '#ee7b1b',
  shadowBlur: 12,
  shadowOffsetX: 0,
  shadowOffsetY: 0,

  'icon-background-shape': {
    stroke: '#edab4f',
    fill: '#f9ecda'
  },
  'icon-image-shape': {
    fill: '#e0952d',
    shadowColor: '',
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0
  }
};


/**
 * 拓扑插件-状态样式-设备故障时样式集合
 * @type attrs 设备故障时样式
 */
export const errorStyles = {
  shadowColor: '#ee2d1b',
  shadowBlur: 12,
  shadowOffsetX: 0,
  shadowOffsetY: 0,

  'icon-background-shape': {
    stroke: '#ce3823',
    fill: '#f5cdc8'
  },

  'icon-image-shape': {
    fill: '#c9161a',
    shadowColor: '',
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0
  }
};



/**
 * 拓扑插件-状态样式-节点不同状态下的样式集合
 * @type attrs 节点各状态下样式
 */
export const stateStyles = {
  // 默认状态
  defaultState: defaultStyles,
  // 不可用/不可选
  disable: disableStyles,
  // 唤起，鼠标经过/悬停
  active: activeStyles,
  // 选择，鼠标单击/双击/框选/拖拽/吸附
  selected: selectedStyles,
  // 告警时
  warning: warningStyles,
  // 错误时
  error: errorStyles,
  // 强化，点亮对比既定节点时，做突出展示
  highlight: null,
  // 弱化，点亮对比别的节点时，做弱化展示
  inactive: null
};


/**
 * 拓扑插件-状态样式-获取节点默认参数配置
 * @param options 扩展参数
 * @returns attrs 节点默认参数配置
 */
export function getGraphStyle(options) {
  const attrs = {...this.defaultStyle};
  if (options) {
    Object.assign(attrs, options);
  }
  return attrs;
}
